import Header from "./Header";
import Footer from "./Footer";

function Terms() {
  return (
    <>
      <Header />

      <section className="my-6">
        <div className="container">
          <span className="text-uppercase text-secondary fw-semibold ls-sm">
            Terms & Conditions
          </span>
          <h2 className="h1 fw-semibold ls-sm text-success lh-1">
            SLN Academy's Terms
          </h2>
          <div className="mt-n3 pt-2">
            <img
              src="/assets/images/line-shap.webp"
              width="230"
              className="mt-2"
            />
          </div>

          <div className="mt-4 lh-md">
            <h4>TERMS & CONDITIONS</h4>
            <p className="mb-0">
              <span className="text-danger">SLN Academy</span>
            </p>
            <p className="mb-0">(Operated by Swinglearn Network LLP)</p>
            <p>Last Updated: 2026</p>

            <h4>1. INTRODUCTION & ACCEPTANCE OF TERMS</h4>
            <p>
              Welcome to SLN Academy, an education platform operated by
              Swinglearn Network LLP, a Limited Liability Partnership registered
              in India.
            </p>
            <p>
              These Terms and Conditions (“Terms”) govern your access to and use
              of:
            </p>
            <ul>
              <li>Our website</li>
              <li>Student portal</li>
              <li>Mobile or web applications</li>
              <li>Courses, tools, scanners, content, and services</li>
            </ul>
            <p>
              By using the platform, you agree to these Terms. If you do not
              agree, discontinue use.
            </p>

            <h4>2. DEFINITIONS</h4>
            <ul>
              <li>SLN Academy – Education brand</li>
              <li>Company – Swinglearn Network LLP</li>
              <li>User – Visitor or student</li>
              <li>Services – Courses, tools, and support</li>
              <li>Platform – Website and applications</li>
            </ul>

            <h4>3. NATURE OF SERVICES</h4>
            <p>SLN Academy provides education only:</p>
            <ul>
              <li>Stock market education</li>
              <li>F&O training</li>
              <li>Skill development programs</li>
              <li>Practice tools and analytics</li>
            </ul>
            <p>We do NOT provide advisory or trading recommendations.</p>

            <h4>4. REGULATORY DISCLOSURE</h4>
            <p>
              Swinglearn Network LLP is an NSE Registered Authorized Person
              under Choice Equity Broking Pvt. Ltd.
            </p>
            <ul>
              <li>Allows broker access facilitation</li>
              <li>Does not allow advisory services</li>
            </ul>

            <h4>5. ELIGIBILITY</h4>
            <ul>
              <li>Users must be 18+</li>
              <li>Provide accurate information</li>
              <li>Misuse may lead to termination</li>
            </ul>

            <h4>6. USER ACCOUNT</h4>
            <ul>
              <li>Keep login credentials secure</li>
              <li>No account sharing</li>
              <li>Report unauthorized access</li>
            </ul>

            <h4>7. COURSE ACCESS</h4>
            <ul>
              <li>Access depends on selected plan</li>
              <li>Content may be updated</li>
            </ul>

            <h4>8. PAYMENTS</h4>
            <ul>
              <li>Fees shown before payment</li>
              <li>Processed via secure gateways</li>
              <li>No storage of card details</li>
            </ul>

            <h4>9. REFUND POLICY</h4>
            <ul>
              <li>Generally non-refundable</li>
              <li>Course-specific exceptions</li>
            </ul>

            <h4>10. INTELLECTUAL PROPERTY</h4>
            <p>All content belongs to Swinglearn Network LLP.</p>
            <ul>
              <li>No copying or redistribution</li>
              <li>No resale without permission</li>
            </ul>

            <h4>11. TOOLS & MARKET DATA</h4>
            <ul>
              <li>Educational use only</li>
              <li>Not trading signals</li>
            </ul>

            <h4>12. INTERNSHIP</h4>
            <ul>
              <li>Learning-based only</li>
              <li>No job guarantee</li>
            </ul>

            <h4>13. CODE OF CONDUCT</h4>
            <ul>
              <li>No piracy</li>
              <li>No abuse</li>
              <li>No misinformation</li>
            </ul>

            <h4>14. THIRD-PARTY SERVICES</h4>
            <p>Not responsible for external platforms.</p>

            <h4>15. LIMITATION OF LIABILITY</h4>
            <ul>
              <li>No liability for losses</li>
              <li>No guarantee of outcomes</li>
            </ul>

            <h4>16. DISCLAIMER</h4>
            <p>Services provided “as is” without warranties.</p>

            <h4>17. INDEMNIFICATION</h4>
            <p>Users agree to protect SLN Academy from claims.</p>

            <h4>18. TERMINATION</h4>
            <p>Access may be suspended for violations.</p>

            <h4>19. MODIFICATIONS</h4>
            <p>Terms may change anytime.</p>

            <h4>20. GOVERNING LAW</h4>
            <p>Applicable laws: India (Uttar Pradesh jurisdiction).</p>

            <h4>21. CONTACT</h4>
            <p className="mb-0">SLN Academy – Swinglearn Network LLP</p>
            <p className="mb-0">Kaushambi, Uttar Pradesh, India</p>
            <p className="mb-0">Email: slnacademyofficial@gmail.com</p>
            <p className="mb-0">Phone: 6386191243</p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Terms;
